module.exports = __webpack_public_path__ + "img/goose4.de001ef1.jpg";